// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".store-pop-up__editor[data-v-497b0390] h1,.store-pop-up__editor[data-v-497b0390] h2,.store-pop-up__editor[data-v-497b0390] h3,.store-pop-up__editor[data-v-497b0390] h4,.store-pop-up__editor[data-v-497b0390] h5,.store-pop-up__editor[data-v-497b0390] h6,.store-pop-up__editor[data-v-497b0390] p,.store-pop-up__editor[data-v-497b0390] span,.store-pop-up__editor[data-v-497b0390] strong{color:#4d4d4f}", ""]);
// Exports
module.exports = exports;
